import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { useState } from "react";
import invitationService from "./invitationService";
import { describeInvitationResults } from "../utils/invitationStatus";

interface ResendInvitationButtonProps {
  emails: string[];
  label?: string;
}

export function ResendInvitationButton({
  emails,
  label = "Resend invitation",
}: ResendInvitationButtonProps) {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState("");

  const cleanEmails = Array.from(
    new Set(emails.map((email) => email.trim().toLowerCase()).filter(Boolean))
  );

  async function resend(): Promise<void> {
    setBusy(true);
    setStatus("");
    try {
      const response = await invitationService.resend(cleanEmails);
      setStatus(
        describeInvitationResults(response.invitations) || "Invitation resent."
      );
    } catch (error: any) {
      setStatus(error?.message || "Failed to resend invitation.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={4}>
      <Button
        variant="outlined"
        size="small"
        onClick={resend}
        disabled={busy || cleanEmails.length === 0}
        data-testid="resend-invitation-button"
      >
        {busy ? <CircularProgress size={16} /> : label}
      </Button>
      {status ? (
        <Typography
          variant="caption"
          color="textSecondary"
          data-testid="resend-invitation-status"
          style={{ whiteSpace: "pre-line" }}
        >
          {status}
        </Typography>
      ) : null}
    </Box>
  );
}
